import { atom } from "jotai";
import { Team, TeamMember } from "@quantizr-engineering/common/types/user";

export interface TeamMembersState {
  loading: boolean;
  data: TeamMember[] | null;
  lastFetched: number | null;
}
export const teamMembersLoadingAtom = atom<boolean>(false);

export const teamMembersErrorAtom = atom<string | null>(null);

export const teamMembersAtom = atom<TeamMembersState>({
  loading: false,
  data: [],
  lastFetched: null,
});

export const artistsAtom = atom<TeamMembersState>({
  loading: false,
  data: [],
  lastFetched: null,
});

export interface TeamsForMemberState {
  loading: boolean;
  data: Team[] | null;
  lastFetched: number | null;
}
export const teamsForMemberLoadingAtom = atom<boolean>(false);

export const teamsForMemberAtom = atom<TeamsForMemberState>({
  loading: false,
  data: [],
  lastFetched: null,
});
